import { PayloadAction } from '@reduxjs/toolkit';
import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';
import customer from '~sagas/customer';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import { GoldConversionStatusEnum, MetalTypeEnum } from '~utils/enums';
import UtilFunctions from '~utils/functions';

export default function* watchGetGoldConversionListing(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldGetGoldConversionListingAttempt', handleGetGoldConversionListing, api);
}

function* handleGetGoldConversionListing(api: GoldGateway, action: PayloadAction<{ customerId?: number } | undefined>,) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const { index, filters: { customerName, idNo, branchId, status, dateTo, dateFrom, metalType } } = reduxState.gold.goldConversion;

    const customerId = action.payload?.customerId;

    if (!index && index !== 0) {
        yield put(combinedActions.goldGetGoldConversionListingFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        return;
    }

    const response = yield* call([api, api.getGoldConversionListing], {
        authToken,
        index,
        customerName: customerName || undefined,
        customerId: customerId || undefined,
        idNo: idNo || undefined,
        branchId: branchId || undefined,
        status: status ? GoldConversionStatusEnum[status as keyof typeof GoldConversionStatusEnum] : undefined,
        dateTo: dateTo || undefined,
        dateFrom: dateFrom || undefined,
        metalType: metalType ? UtilFunctions.Misc.getEnumValueByKey(MetalTypeEnum, metalType) : undefined,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.goldGetGoldConversionListingFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.goldGetGoldConversionListingSuccess(response.data));
    }
}
